import { assert, isNotBlank, formatString, isElement } from 'ajax-form-submit/js-utils'
import {
  querySelector,
  elementIs,
  addClass,
  registerEvent,
  hasClass,
  stopDefaultEvent,
  registerMutationObserver
} from 'ajax-form-submit/js-dom-utils'

import { createDatasetHelper } from 'ajax-form-submit/js-dataset-helper'
import { createInstanceMap } from 'ajax-form-submit/js-cache'

const CLASS_NAME = 'js-countdown-button'
const INIT_CLASS_NAME = `${CLASS_NAME}-init`

class JsCountdownButton {
  static prefix = 'jcb'
  static instance = createInstanceMap(
      el => elementIs(el, 'button') && hasClass(el, CLASS_NAME) && !hasClass(el, INIT_CLASS_NAME),
      el => new JsCountdownButton(el))

  #datasetHelper = createDatasetHelper(JsCountdownButton.prefix)
  #root
  #defaultText
  #textFormat
  #buttonText
  #second
  #storageKey
  #interval

  constructor(el) {
    assert(elementIs(el, 'button'), 1, 'HTMLElement')
    this.#root = el
    this.#defaultText = this.#root.textContent
    this.#textFormat = this.#datasetHelper.getValue(el, 'format', '{0}')
    this.#buttonText = this.#defaultText + this.#textFormat
    this.#second = parseInt(this.#datasetHelper.getValue(el,'second', '60')) * 1000
    this.#storageKey = this.#datasetHelper.getValue(el,'storage')

    const eventName = this.#datasetHelper.getValue(el, 'event')
    if (isNotBlank(eventName)) {
      registerEvent(el, eventName, event => {
        stopDefaultEvent(event)
        this.startInterval()
      })
    }
    addClass(el, INIT_CLASS_NAME)
    this.startInterval()
  }

  startInterval() {
    this.stopInterval()
    this.#root.setAttribute('disabled', 'true')
    const startTime = this.#storageKey ? localStorage.getItem(this.#storageKey) : Date.now()
    const targetTime = parseInt(startTime) + this.#second

    this.#interval = setInterval(() => {
      const diff = parseInt((targetTime - Date.now()) / 1000)
      if (diff > 0) {
        this.#root.setAttribute('disabled', 'true')
        this.#root.textContent = formatString(this.#buttonText, [ diff ])
      } else {
        this.stopInterval()
        this.#root.removeAttribute('disabled')
        this.#root.textContent = this.#defaultText
      }
    }, 1000)
  }

  stopInterval() {
    if (this.#interval)
      clearInterval(this.#interval)
  }
}

export default JsCountdownButton
window && (window.JsCountdownButton = JsCountdownButton)

window.addEventListener('DOMContentLoaded', event => {
  const selector = `.${CLASS_NAME}`
  querySelector(selector).forEach(el =>  JsCountdownButton.instance.create(el))
  registerMutationObserver(el => {
    if (isElement(el) && hasClass(el, CLASS_NAME)) {
        querySelector(selector, el, true).forEach(el => JsCountdownButton.instance.create(el))
    }
  })
}, { once: true })
